import { authMatchGuard } from '@at/auth';

export const invitesRoutes = {
  join: [
    {
      path: '',
      loadComponent: () =>
        import('./pages/invitation/invitation.component').then((m) => m.InvitationComponent),
    },
    {
      path: 'accept',
      loadComponent: () =>
        import('./pages/invitation/accept/accept.component').then((m) => m.AcceptComponent),
      canMatch: [authMatchGuard],
    },
  ],
};
